export default "__VITE_ASSET__BR6wKI6p__"